import React, { createContext, useState, useEffect, useContext } from 'react';
import { api } from '../../../config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = async () => {
        const storedUser = localStorage.getItem('authUser');
        let restoredUser = null;
        if (storedUser) {
            try {
                restoredUser = JSON.parse(storedUser);
            } catch { /* ignore */ }
        }

        try {
            const response = await api.get('/me');

            if (response.data.authenticated && response.data.user) {
                setUser(response.data.user);
                localStorage.setItem('authUser', JSON.stringify(response.data.user));
                if (response.data.token) {
                    localStorage.setItem('authToken', response.data.token);
                }
            } else if (restoredUser) {
                setUser(restoredUser);
            } else {
                setUser(null);
                localStorage.removeItem('authUser');
            }
        } catch (error) {
            console.error('Auth check failed:', error);

            if (error.response?.status === 401 || error.response?.status === 403) {
                localStorage.removeItem('authUser');
                setUser(null);
            } else {
                if (restoredUser) {
                    console.log('Using stored user data as fallback');
                    setUser(restoredUser);
                } else {
                    setUser(null);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    const login = (userData, token) => {
        setUser(userData);
        if (userData) {
            localStorage.setItem('authUser', JSON.stringify(userData));
        }
        if (token) {
            localStorage.setItem('authToken', token);
        }
    };

    const logout = async () => {
        try {
            await api.post('/logout');
        } catch (error) {
            console.error('Logout failed:', error);
        } finally {
            setUser(null);
            localStorage.removeItem('authUser');
            localStorage.removeItem('authToken');
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, fetchUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
